import {
  ComponentProps,
  CSSProperties,
  FC,
  // useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
// import { useDispatch } from 'react-redux';
// import { isMobile } from 'utils/is-mobile';
import { NewCasinoGame } from 'interfaces/new-casino';
import { Loading } from 'components/Loading';
import { CasinoGameCard as CasinoGameCardComponent } from 'newcomponents/Shared/casino/CasinoGameCard';
// import { useClickOutside } from 'hooks/useClickOutside';
// import { setMobileActiveCardID } from 'store/actions/new-casino';
import { useGamesLoadMore } from '../../hooks/useGamesLoadMore';
import { useCasinoGamesConditionalsValues } from '../../providers/CasinoGamesConditionalsProvider';
import { useCasinoGamesConfigsValues } from '../../providers/CasinoGamesConfigsContext';

interface ICasinoGamesLazyLoadProps {
  gamesCount: number;
  data: NewCasinoGame[];
  loadMoreContainerStyles: { className: string; style: CSSProperties };
  loadMoreFunctionalityAvailable: boolean;
  CasinoGameCard: (
    props: Pick<
      ComponentProps<typeof CasinoGameCardComponent>,
      'game' | 'index'
    >
  ) => ReturnType<typeof CasinoGameCardComponent>;
}

const TRIGGER_ELEMENT_THRESHOLD = 0.5;

const createIntersectionObserver = (callback: () => void) => {
  return new IntersectionObserver(
    ([entry], observer) => {
      if (!entry.isIntersecting) {
        return;
      }

      observer.unobserve(entry.target);
      observer.disconnect();
      callback();
    },
    { threshold: TRIGGER_ELEMENT_THRESHOLD }
  );
};

export const GamesLazyLoad: FC<ICasinoGamesLazyLoadProps> = ({
  data,
  loadMoreContainerStyles,
  loadMoreFunctionalityAvailable,
  CasinoGameCard
}) => {
  const { handleLoadMore } = useGamesLoadMore();
  const { conditionals } = useCasinoGamesConditionalsValues();
  const { computedConfigs } = useCasinoGamesConfigsValues();
  const [triggerCard, setTriggerCard] = useState<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  // const dispatch = useDispatch();

  // const setMobileActiveCardCLickHandler = useCallback(
  //   (id: null | string = null) => {
  //     debugger;
  //
  //     isMobile() && dispatch(setMobileActiveCardID(id));
  //   },
  //   []
  // );
  //
  // useClickOutside(containerRef, () => {
  //   debugger;
  //
  //   isMobile() && setMobileActiveCardCLickHandler(null);
  // });

  useEffect(() => {
    if (!triggerCard) {
      return;
    }

    const observer = createIntersectionObserver(handleLoadMore);
    observer.observe(triggerCard);

    return () => {
      if (!triggerCard) {
        return;
      }

      observer.unobserve(triggerCard);
      observer.disconnect();
    };
  }, [triggerCard]);

  return (
    <>
      <div
        ref={containerRef}
        className={loadMoreContainerStyles.className}
        style={loadMoreContainerStyles.style}
      >
        {data.map((game, index) => (
          <div
            key={game.id}
            ref={(elem: HTMLDivElement) => {
              if (data.length - computedConfigs.gamesPerRow !== index) {
                return;
              }

              if (!elem) {
                return;
              }

              if (loadMoreFunctionalityAvailable) {
                setTriggerCard(elem);
              } else {
                setTriggerCard(null);
              }
            }}
            // onClick={() => {
            //   setMobileActiveCardCLickHandler(game.id);
            // }}
          >
            <CasinoGameCard game={game} />
          </div>
        ))}
      </div>
      {conditionals.queryLoading && (
        <Loading className="x-casinoGames__loading" />
      )}
    </>
  );
};
